import { Provider } from "react-redux";
import "./App.scss";

import { BrowserRouter as Router } from "react-router";

import { store } from "./redux/store";
import Header from "./components/Header/Header";

import Footer from "./components/Footer/Footer";
import MainSwitch from "./components/MainRouter/MainSwitch";
import { Providers } from "./providers/Providers";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Providers>
          <Header />
          <MainSwitch />
          <Footer />
        </Providers>
      </Router>
    </Provider>
  );
};

export default App;
